/**
 * @generated SignedSource<<ac8c76175653d149dbd17646613b7907>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientForm_viewer$data = {
  readonly account: {
    readonly clients: ReadonlyArray<{
      readonly active: boolean;
      readonly id: number;
      readonly name: string;
    }>;
    readonly id: number;
    readonly name: string;
  };
  readonly " $fragmentType": "ClientForm_viewer";
};
export type ClientForm_viewer$key = {
  readonly " $data"?: ClientForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientForm_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClientForm_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "clients",
          "kind": "LinkedField",
          "name": "clients",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "active",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};
})();

(node as any).hash = "8182657ff9e75201fb3658b41ecd808e";

export default node;
